import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { EditionShell } from "../components/dnh/feed/EditionShell";
import { StoryGrid } from "../components/dnh/StoryGrid";
import { useBookmarks } from "../components/dnh/BookmarkContext";
import { useAuth } from "../components/dnh/AuthContext";
import { ScopedNewsSearch } from "../components/dnh/search/ScopedNewsSearch";
const BASE = process.env.REACT_APP_BACKEND_URL;
export const SavedStoryList = ({ prefix = "saved" }) => {
  const { user } = useAuth(); const { bookmarkedIds, syncing } = useBookmarks();
  const [stories, setStories] = useState([]), [loading, setLoading] = useState(true), [error, setError] = useState(false), [retry, setRetry] = useState(0);
  const [query, setQuery] = useState("");
  const key = [...bookmarkedIds].sort().join(",");
  useEffect(() => {
    if (syncing) return;
    let active = true; setLoading(true); setError(false); setStories([]);
    (async () => {
      try {
        if (user) {
          const res = await fetch(`${BASE}/api/user/saved?q=${encodeURIComponent(query)}`, { credentials: "include" });
          if (!res.ok) throw new Error(); const data = await res.json(); if (active) setStories(data.saved || []);
        } else {
          const ids = key ? key.split(",") : []; const result = [];
          for (let i=0; i<ids.length; i+=60) {
            const res = await fetch(`${BASE}/api/stories/by-ids`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ ids: ids.slice(i, i+60), q: query }) });
            if (!res.ok) throw new Error(); result.push(...(await res.json()).stories);
          }
          if (active) setStories(result);
        }
      } catch { if (active) setError(true); } finally { if (active) setLoading(false); }
    })();
    return () => { active = false; };
  }, [user, key, syncing, retry, query]);
  const toolbar = <ScopedNewsSearch prefix={`${prefix}-search`} scope="saved stories" value={query} onSubmit={setQuery} />;
  if (syncing || loading) return <>{toolbar}<p data-testid={`${prefix}-loading`} className="py-12 animate-pulse">Loading saved stories…</p></>;
  if (error) return <>{toolbar}<p role="alert" data-testid={`${prefix}-error`}>Your saved stories could not be loaded. <button data-testid={`${prefix}-retry`} onClick={() => setRetry(v => v+1)} className="underline">Retry</button></p></>;
  return <>{toolbar}{stories.length ? <><p data-testid={`${prefix}-count`} className="text-[10px] text-[var(--muted)] mb-3">{stories.length} saved stories</p><StoryGrid stories={stories} testId={`${prefix}-stories-grid`} /></> : <div data-testid={`${prefix}-empty-state`} className="py-16"><h2 className="font-serif text-lg">{query ? "No saved stories match this query" : "Nothing saved yet"}</h2><Link data-testid={`${prefix}-explore-link`} to="/today" className="inline-flex items-center min-h-11 mt-6 underline">Explore today’s stories →</Link></div>}</>;
};
export default function SavedStories() {
  return <EditionShell title="Saved stories" activeNav="Saved" testId="saved"><SavedStoryList /></EditionShell>;
}